import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useParams, Link } from "react-router-dom";

function PintaHelp() {
  const { lang } = useParams();

  const textByLang = {
    es: {
      heading: "Próximamente",
      message:
        "Esta sección estará disponible pronto. Mientras tanto, puedes volver a la página de Pinta.",
      button: "Volver a Pinta",
    },
    en: {
      heading: "Coming Soon",
      message:
        "This section will be available soon. In the meantime, you can return to the Pinta page.",
      button: "Back to Pinta",
    },
    fr: {
      heading: "Bientôt disponible",
      message:
        "Cette section sera bientôt disponible. En attendant, vous pouvez revenir à la page Pinta.",
      button: "Retour à Pinta",
    },
    de: {
      heading: "Kommt bald",
      message:
        "Dieser Bereich wird bald verfügbar sein. In der Zwischenzeit können Sie zur Pinta-Seite zurückkehren.",
      button: "Zurück zu Pinta",
    },
    it: {
      heading: "Prossimamente",
      message:
        "Questa sezione sarà disponibile presto. Nel frattempo, puoi tornare alla pagina di Pinta.",
      button: "Torna a Pinta",
    },
  };

  const t = textByLang[lang] || textByLang.en;

  return (
    <Box sx={{ maxWidth: 900, margin: "0 auto", padding: 2, mt: 4, textAlign: "center" }}>
      <Typography variant="h3" gutterBottom>
        {t.heading}
      </Typography>
      <Typography variant="h6" gutterBottom>
        {t.message}
      </Typography>
      <Box sx={{ mt: 4 }}>
        <Button
          component={Link}
          to={`/${lang}/pinta`}
          variant="contained"
          color="primary"
        >
          {t.button}
        </Button>
      </Box>
    </Box>
  );
}

export default PintaHelp;
